import type { RdoStatus } from "@/adapters/api";
import type { BadgeVariant } from "@/components/ui/badge.tsx";

interface RdoStatusPresentation {
	label: string;
	variant: BadgeVariant;
}

export const RDO_STATUS: Record<RdoStatus, RdoStatusPresentation> = {
	draft: { label: "Rascunho", variant: "secondary" },
	generating: { label: "Gerando PDF", variant: "warning" },
	finalized: { label: "Finalizado", variant: "success" },
	failed: { label: "Falha na geração", variant: "destructive" },
	superseded: { label: "Substituído", variant: "outline" },
};

export const RDO_STATUSES = Object.keys(RDO_STATUS) as RdoStatus[];

export function rdoStatusLabel(status: RdoStatus): string {
	return RDO_STATUS[status].label;
}

export function isRdoEditable(status: RdoStatus): boolean {
	return status === "draft";
}

export function isRdoReadOnly(status: RdoStatus): boolean {
	return !isRdoEditable(status);
}

export function hasRdoDownload(status: RdoStatus, hasPdf: boolean): boolean {
	return (status === "finalized" || status === "superseded") && hasPdf;
}
